import { formatCurrency } from "@/common/utils/formatters";

interface ResumeItemProps {
  label: string;
  value: string | number;
  textClassName?: string;
}

const ResumeItem = ({ label, value, textClassName = "" }: ResumeItemProps) => {
  return (
    <div>
      <p className={`font-light italic text-[14px] ${textClassName}`}>{label}</p>
      <p className={`text-[18px] ${textClassName}`}>{formatCurrency(Number(value) || 0)}</p>
    </div>
  )
}

export default ResumeItem